<div class="table-column-date-filter">
    <input type="text"
           class="form-control form-control-sm table-column-date-filter-input"
           autocomplete="off"
           [placeholder]="datePlaceholder"
           [ngModel]="displayValue"
           [ngModelOptions]="{standalone: true}"
           (ngModelChange)="onDisplayValueChange($event)"
           (blur)="onDisplayBlur()"
           (click)="$event.stopPropagation()" />
    <button type="button"
            class="table-column-date-filter-btn"
            bsDatepicker
            #dp="bsDatepicker"
            triggers=""
            container="body"
            placement="bottom"
            [outsideClick]="true"
            [bsConfig]="bsConfig"
            [bsValue]="selectedDate"
            (bsValueChange)="onPickerDateChange($event)"
            (click)="togglePicker($event)"
            [attr.aria-label]="'Select date'">
        <i class="flaticon2-calendar-9"></i>
    </button>
</div>
